import { EmbeddedPodlet } from "@mobility-item-page/client";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import { usePodlets } from "../../podlets.ts";

export const FinanceSection = () => {
  const { pfFinanceCalculator, pfFinanceLinks, pfFinancialArea } = usePodlets();
  const { isMobile } = useAppConfig();

  if (pfFinanceCalculator || pfFinanceLinks) {
    return (
      <div className={isMobile ? "border-t" : "mt-40 border-t"}>
        <EmbeddedPodlet className="mt-40" response={pfFinanceCalculator} cautiouslyReloadScriptOnHydrationError />
        <EmbeddedPodlet className="-mx-16 md:mr-8 -mb-16 pt-24" response={pfFinanceLinks} />
      </div>
    );
  }
  if (pfFinancialArea) {
    return <EmbeddedPodlet className="mt-40" response={pfFinancialArea} />;
  }
  return null;
};
